import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'max-sm:!py-16 sm:w-[640px]',
    modalWrapper: 'max-sm:h-full max-sm:!max-h-screen'
  }
});
